<template>
    <div class="reports">
        <ReportList v-if="reports.length" :reports="reports" />

        <div class="reports__empty" v-else>
            <p>
                <span>Obecnie nie ma żadnych zgłoszeń</span>
            </p>
        </div>
    </div>
</template>

<script>
import ReportList from "@/components/reports/list/ReportList";

export default {
    name: "ReportsContainer",
    components: {
        ReportList,
    },
    props: {
        reports: {
            required: true,
            type: Array,
        },
    },
};
</script>

<style lang="scss">
.reports {
    flex: 1;

    &__empty {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 1rem;
    }
}
</style>
